import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@4.3.0_webpack@3.12.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sxzz",
  "use": "icon-sxzz-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sxzz\"><path d=\"M623.2 544.4c-44.9-23.4-95.9-36.6-150-36.6-179.5 0-325 145.5-325 325 0 7.3 0.3 14.5 0.7 21.7 10-0.1 20.1-0.4 30-0.9-0.5-6.9-0.7-13.8-0.7-20.8 0-162.9 132.1-295 295-295 49.5 0 96 12.2 137 33.7l13-27.1z\" p-id=\"1296\" /><path d=\"M473.1 89.8c-124 0-223 99-223 223s99 223 223 223 223-99 223-223-98.9-223-223-223z m0 416c-107.3 0-193-85.7-193-193s85.7-193 193-193 193 85.7 193 193-85.7 193-193 193zM149 853.8a15 15 0 1 0 30 0 15 15 0 1 0-30 0zM875.8 725L710 606v89H437v28m0.1 84L603 925.8V837h273v-28M602.3 558.3a15 15 0 1 0 30 0 15 15 0 1 0-30 0z\" p-id=\"1297\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sxzz.svg
// module id = 2Pcr
// module chunks = 38